import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Layout from '../../componentsv2/Layout';
import Skeleton from '../../componentsv2/Skeleton';
import Section from '../../componentsv2/Section';
import { COLORS } from '../../themev2';

export default function RevolvingCreditLineSkeleton() {
  return (
    <Layout>
      <Grid container rowSpacing={2}>
        {/* Header and Actions */}
        <Grid item xs={8} md={9} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Skeleton width="60%" height="36px" />
          <Skeleton width="40%" height="21px" />
        </Grid>
        <Grid item xs={4} md={3} sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
          <Skeleton width={120} height="40px" />
        </Grid>

        {/* Summary Cards */}
        <Grid item xs={12} md={6} lg={5}>
          <Section isFullHeight sx={{ background: COLORS.brand.white }}>
            <Grid container rowSpacing={2}>
              <Grid item xs={12}>
                <Skeleton width={120} height="40px" />
              </Grid>

              {/* Amount */}
              <Grid item xs={12}>
                <Skeleton width={180} height="40px" />
              </Grid>
              <Grid item xs={12} sx={{ py: '1.5rem' }}>
                <Skeleton width="100%" height="8px" />
              </Grid>

              {/* Utilized & Credit limit */}
              <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Skeleton width={120} height="20px" />
                <Skeleton width={150} height="20px" />
              </Grid>
              <Grid
                item
                xs={6}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  alignItems: 'flex-end',
                }}
              >
                <Skeleton width={120} height="20px" />
                <Skeleton width={150} height="20px" />
              </Grid>
            </Grid>
          </Section>
        </Grid>
        <Grid item xs={12} md={6} lg={7}>
          <Section isFullHeight sx={{ background: COLORS.brand.white }}>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    backgroundColor: COLORS.gray[100],
                    flex: 1,
                    borderRadius: '12px',
                    padding: '1em',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: '1em',
                  }}
                >
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1em' }}>
                    <Skeleton width={120} height="40px" />
                    <Skeleton width={180} height="40px" />
                    <Divider sx={{ borderColor: COLORS.gray[500], width: '100%' }} />
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1em' }}>
                    <Skeleton width={120} height="40px" />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    backgroundColor: COLORS.gray[100],
                    flex: 1,
                    borderRadius: '12px',
                    padding: '1em',
                    height: '100%',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: '1em',
                  }}
                >
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1em' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <Skeleton width={120} height="40px" />
                      <Skeleton width="24px" height="24px" variant="circular" />
                    </Box>
                    <Skeleton width={180} height="40px" />
                    <Divider sx={{ borderColor: COLORS.gray[500], width: '100%' }} />
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1em' }}>
                    <Skeleton width={120} height="40px" />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Section>
        </Grid>

        {/* Latest Activity Title */}
        <Grid item xs={12}>
          <Skeleton width="30%" height="28px" />
        </Grid>

        {/* Tabs and Table Skeleton */}
        <Grid item xs={12}>
          <Box
            sx={{
              background: '#fff',
              borderRadius: '12px',
              p: 3,
              gap: '1em',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Skeleton width="30%" height="36px" />
            <Skeleton width="100%" height={400} />
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
}
